/**
 * 用户访问轨迹（日志）
 * 服务接口文档：http://wiki.tools.zuzuche.com/pages/viewpage.action?pageId=64258387
 */
import axios from 'axios';
import { Base64 } from 'js-base64';
import * as utilCookie from '../util-lib/cookie';
import * as utilObject from '../util-lib/object';

const DEFAULT_PARAMS = {
  auto: true,
  env: 'test',
  async saveId(value, env) {
    return utilCookie.set('user_action_id', value, {
      path: '/',
      domain: env === 'test' ? document.domain : '.zuzuche.com',
      expires: 1000
    });
  },
  async getId() {
    return utilCookie.get('user_action_id');
  },
  async getUserId() {
    return utilCookie.get('cdb_uid');
  }
};


/**
 * 初始化
 * @param {object} params 参数
 * @property {string} params.env 环境：test, prod
 * @property {boolean} params.auto = true 是否自动记录
 * @property {function} params.saveId 自定义存储 service_code
 * @property {function} params.getId 自定义获取 service_code
 * @property {function} params.getUserId 自定义获取用户ID cdn_uid
 */
export function init(params = {}) {
  return new UserTrack(params);
}

// 记录轨迹日志
export function log(data) {
  if (!UserTrack.instance) {
    // eslint-disable-next-line
    console.warn('警告：未初始化 user-track-sdk');
  }

  UserTrack.instance.log(data);
}

// 获取服务代码
export async function getId() {
  if (!UserTrack.instance) {
    // eslint-disable-next-line
    console.warn('警告：未初始化 user-track-sdk');
  }

  return UserTrack.instance.getId();
}


class UserTrack {
  static instance = null;

  constructor(params) {
    if (UserTrack.instance) {
      return UserTrack.instance;
    }
    UserTrack.instance = this;
    //
    this.fetching = null;

    this.params = { ...DEFAULT_PARAMS, ...params };

    if (this.params.auto) {
      this.log();
    }
  }


  async createServiceCode() {
    if (this.fetching) {
      return this.fetching;
    }

    this.fetching = this._createServiceCode();
    return this.fetching;
  }

  async _createServiceCode() {
    const api = this.params.env === 'test'
      ? 'https://w_service-code.zuzuche.net/api/tool/service_code/get_code.php'
      : 'https://w.zuzuche.com/api/tool/service_code/get_code.php';

    try {
      const body = await axios.get(api);
      return utilObject.get(body, 'data.data.service_code', '');
    } catch (error) {
      return '';
    }
  }

  async log(data) {
    const uid = await this.params.getUserId();
    const id = await getId();
    data = {
      url: utilObject.get(window, 'location.href'),
      refer: utilObject.get(window, 'document.referrer'),
      ua: utilObject.get(window, 'navigator.userAgent'),
      login_id: uid,
      service_code: id,
      ...data
    };

    const api = this.params.env === 'test'
      ? 'https://w_service-code.zuzuche.net/api/tool/service_code/save_track.php'
      : 'https://w.zuzuche.com/api/tool/service_code/save_track.php';

    data = Base64.encode(JSON.stringify(data));
    axios.post(api, `service_code=${id}&data=${data}`, {
      headers: { 'content-type': 'application/x-www-form-urlencoded' }
    });
  }

  async getId() {
    let id = await this.params.getId();

    if (!id) {
      id = await this.createServiceCode();
    }

    id && this.params.saveId(id, this.params.env);

    return id;
  }
}
